'use strict';

import {element_exists} from "../../functions";

var Inputmask = require('inputmask');

export var fnViiaTransactionTableFilters = function () {

    let tableName = '#datatable-viia-transactions';

    if (!element_exists(tableName)) return false;

    let fromDate = $('#transaction_from_date');
    let toDate = $('#transaction_to_date');

    var im = new Inputmask({mask: "99-99-9999", placeholder: "dd-mm-yyyy"});
    im.mask(fromDate);
    im.mask(toDate);
}